import * as mobx from 'mobx';
import { IntlShape } from 'react-intl';
import { getShortRichTextLengthError } from '../../../../../infrastructure/utils/form-validation.utils';
import { IGuidlinesFormContainerProps } from './guidelines-form.container';
import { OpenFrom } from '../../../../../tracking-service/tracking-values';

export default class GuidelinesFormVM {
    @mobx.observable
    public isSaving: boolean;
    @mobx.observable
    public isEditMode: boolean;
    @mobx.observable
    public openFrom: OpenFrom;
    private intl: IntlShape;
    private handleEventNotesChange: (eventNotes: string, openFrom: OpenFrom) => Promise<boolean>;
    public setEventNotes: (value: string) => void;
    public getEventNotes: () => string;
    public trackGuidelinesMixPanel: (openFrom: OpenFrom, dataSaved: boolean) => void;

    @mobx.action
    public initialize(formProps: IGuidlinesFormContainerProps) {
        this.intl = formProps.intl;
        this.handleEventNotesChange = formProps.handleEventNotesChange;
        this.isEditMode = formProps.isEditMode;
        this.openFrom = formProps.openFrom;
        this.setEventNotes = formProps.setEventNotes;
        this.getEventNotes = formProps.getEventNotes;
        this.trackGuidelinesMixPanel = formProps.trackGuidelinesMixPanel;
    }

    @mobx.action
    public formSubmitAction = () => {
        this.isSaving = true;
        return this.handleEventNotesChange(this.getEventNotes(), this.openFrom).finally(() => {
            mobx.runInAction(() => {
                this.isSaving = false;
            });
        });
    };

    @mobx.action
    public getEventNotesError(): boolean {
        return !!this.getEventNotesLengthError();
    }

    @mobx.action
    public getEventNotesLengthError() {
        return this.getEventNotes()
            ? getShortRichTextLengthError(
                this.intl.formatMessage(
                    {
                        id: 'oe.control.eventGuidelines',
                        defaultMessage: 'Event Guidelines',
                        description: 'Label text',
                    }),
                this.getEventNotes(),
            ) : null;
    }
}
